var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Link as ReactLink } from 'react-router-dom';
import styled, { css } from '@xstyled/styled-components';
var StyledLink = styled(ReactLink)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: inherit;\n  cursor: pointer;\n\n  :visited {\n    color: inherit;\n  }\n  :hover {\n    color: inherit;\n  }\n  :active {\n    color: inherit;\n  }\n  :focus {\n    outline: none;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  color: inherit;\n  cursor: pointer;\n\n  :visited {\n    color: inherit;\n  }\n  :hover {\n    color: inherit;\n  }\n  :active {\n    color: inherit;\n  }\n  :focus {\n    outline: none;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var disabled = _a.disabled;
    return disabled
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          pointer-events: none;\n          opacity: 0.5;\n        "], ["\n          pointer-events: none;\n          opacity: 0.5;\n        "]))) : null;
}, function (_a) {
    var $decorate = _a.$decorate;
    return $decorate
        ? css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          text-decoration: underline;\n        "], ["\n          text-decoration: underline;\n        "]))) : null;
}, function (_a) {
    var variant = _a.variant;
    return variant
        ? css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          font-weight: ", ";\n        "], ["\n          font-weight: ", ";\n        "])), variant) : null;
});
export default StyledLink;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
